module.exports = __webpack_public_path__ + "img/GoogleReview.efff8e67.png";